import { get } from 'lodash';
import React, { Component } from 'react';
import styled from 'styled-components';
import { ERROR_CODES } from '@upsolve/shared';

import P from '../Type/Paragraph.p';
import { Button } from '../Inputs/Button.span';
import Input from '../Inputs/Input.input';
import submitLead from './submitLead';

class LeadForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filer: {
        name: null,
        email: null,
        phoneNumber: null,
        zipcode: null,
      },
      valid: false,
      success: false,
      error: null,
      submitted: false,
    };
  }

  updateHelper(key, value) {
    const newState = {
      ...this.state,
      filer: {
        ...this.state.filer,
        [key]: value,
      },
    };
    if ((newState.email || '').length > 5
      && (newState.email || '').includes('@')
      && (newState.phoneNumber || '').length > 6
      && (newState.zipcode || '').length > 4) {
      newState.valid = true;
    }
    this.setState(newState);
  }

  async submitHelper() {
    const { filer, success } = this.state;
    // Don't run if we've already submitted
    if (success === true) return;
    // Otherwise try it out
    this.setState(prevState => ({ ...prevState, submitted: true }));
    try {
      await submitLead({
        type: 'bankruptcy',
        name: filer.name,
        email: filer.email,
        phoneNumber: filer.phoneNumber,
        zipcode: filer.zipcode,
      });
      this.setState(prevState => ({ ...prevState, error: null, success: true, submitted: false }));
    } catch (e) {
      this.setState(prevState => ({
        ...prevState,
        error: get(e.response, 'data.error') || { message: 'An error was hit, please try submitting again.' },
        submitted: false,
      }));
    }
  }

  render() {
    const { error, submitted, success } = this.state;

    return (
      <LeadFormWrapper
        onSubmit={(e) => {
          e.preventDefault();
          this.submitHelper(data.site.siteMetadata.env.UPSOLVE_API_URL);
        }}
      >
        <label>
          First and Last Name
          <Input type="text" disabled={success === true} onChange={e => this.updateHelper('name', e.target.value)} />
        </label>
        <label>
          Email
          <Input type="text" disabled={success === true} onChange={e => this.updateHelper('email', e.target.value)} />
        </label>
        <label>
          Phone Number
          <Input type="text" disabled={success === true} onChange={e => this.updateHelper('phoneNumber', e.target.value)} />
        </label>
        <label>
          Zipcode
          <Input type="text" disabled={success === true} onChange={e => this.updateHelper('zipcode', e.target.value)} />
        </label>
        {error != null && <div className="cta__external__form__error">
          {error.code === ERROR_CODES.INVALID_EMAIL && <P>Please enter a valid email so we can send you information to help.</P>}
          {error.code === ERROR_CODES.INVALID_PHONE_NUMBER && <P>Please enter a valid US phone number so we can get you in touch with help.</P>}
          {error.code === ERROR_CODES.INVALID_ZIPCODE && <P>Please enter a valid zipcode so we can find nearby help.</P>}
          {error.code === ERROR_CODES.FILER_EXISTS && <P>It looks like we already have your information on file!</P>}
          {error.code == null && <P>There was an error. Please check your information and try again.</P>}
        </div>}
        {success === true && <div className="cta__external__form__success">
          <b>Great!</b> You will receive more information from our partners soon.
        </div>}
        <Button type="submit" size="lg" disabled={success === true || submitted === true}>Connect to Help</Button>
        <div className="terms">
          You agree to Upsolve's <a href="/terms-of-service">Terms of Service</a>
        </div>
      </LeadFormWrapper>
    );
  }
}

const LeadFormWrapper = styled.form`
  padding: 0;
  margin: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  label {
    font-size: 13px;
    font-weight: 500;
    margin: 0.25em 0 0.5em;
    color: ${props => props.theme.colors.gray['900']};
  }
  small {
    width: 100%;
    text-align: center;
    margin-top: 0.2em;
  }
  ol, ul {
    padding: 0;
    margin: 0 1em;
    li {
      margin-bottom: 0.5em;
    }
  }
  div.terms {
    margin-top: 4px;
    text-align: center;
    font-size: 13px;
    color: ${props => props.theme.colors.gray['900']};
    & > a, & > a:hover {
      color: ${props => props.theme.colors.gray['900']};
      background: none;
      border: none;
      box-shadow: none;
      text-decoration: underline;
    }
  }
  button, button:hover, button:active {
    background: linear-gradient(270deg,#ff863b -65.78%, #f66161 45.1%);
    box-shadow: 0 6px 24px rgba(0, 0, 0, 0.1);
    border: none;
    border-bottom: 4px solid #d13f3f;
    border-radius: 6px;
    margin: 0.5em 0 0;
    width: 100%;
  }
  .cta__external__form__error {
    margin: 0.5em 0 0;
    padding: 0.25em 1.5em;
    border-radius: 0.25em;
    background: ${props => props.theme.colors.red['500']};
    color: white;
  }
  .cta__external__form__success {
    margin: 0.5em 0 0;
    padding: 0.75em 1.5em;
    border-radius: 0.25em;
    background: ${props => props.theme.colors.green['500']};
    color: white;
  }
`;

export default LeadForm;
